<address class="youth-info-center-card-address">
  <ul>
    <li>
      {{ youthInfoCenterStreet }}
    </li>
    <li>
      <span [class.line-break]="isMobile$ | async">{{ youthInfoCenterZipCode }} - {{ youthInfoCenterCity }}</span>
      <a
        *ngIf="youthInfoCenterMapLink"
        class="link--primary youth-info-center-card-address__map"
        [href]="youthInfoCenterMapLink"
        target="_blank"
        [attr.aria-label]="linkAriaLabel"
        (click)="
          trackEvent({
            category: 'Accompagnement',
            action: 'Click Voir la carte',
            type: 'navigation'
          })
        "
      >
        Voir la carte
        <mat-icon
          svgIcon="external_link"
          class="youth-info-center-card-address__map__icon"
          role="presentation"
        ></mat-icon>
      </a>
    </li>
  </ul>
</address>
